import {TradePartners} from "../../models/accounting/InvoiceTradePartner";
import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {
    FETCH_OUTGOING_INVOICE_PROJECT_META,
    FETCH_OUTGOING_INVOICE_PROJECT_META_ERROR,
    FETCH_OUTGOING_INVOICE_PROJECT_META_SUCCESS,
    FETCH_OUTGOING_INVOICE_TRADE_PARTNERS,
    FETCH_OUTGOING_INVOICE_TRADE_PARTNERS_ERROR,
    FETCH_OUTGOING_INVOICE_TRADE_PARTNERS_SUCCESS,
    OutgoingInvoiceTemplateActionTypes
} from "../../actions/account-book/OutgoingInvoiceTemplateActions";
import {InvoiceProjectMeta} from "../../models/accounting/InvoiceProjectMeta";

/**
 * Represents the state for outgoing invoice templates, including trade partners and project metadata.
 */
export interface OutgoingInvoiceTemplateState {
    /** The list of trade partners available for selection. */
    tradePartners: Nullable< TradePartners >
    /** Metadata related to the project for which the invoice is being generated. */
    meta: Nullable<InvoiceProjectMeta>
    /** The request status for fetching project metadata. */
    metaRequest: RequestState
    /** The request status for fetching trade partners. */
    request: RequestState
}

/**
 * Initial state for the outgoing invoice template.
 */
const initialState: OutgoingInvoiceTemplateState = {
    tradePartners: null,
    meta: null,
    metaRequest: getInitialRequestState(),
    request: getInitialRequestState()
}

/**
 * Reducer that handles actions related to outgoing invoice templates.
 * Manages fetching of trade partners and project metadata.
 * 
 * @param state The current state of the outgoing invoice template.
 * @param action The action being dispatched.
 * @returns The new state after applying the action.
 */
export function OutgoingInvoiceTemplateReducer(
    state: OutgoingInvoiceTemplateState = initialState,
    action: OutgoingInvoiceTemplateActionTypes
) {
    switch( action.type  ) {
        case FETCH_OUTGOING_INVOICE_TRADE_PARTNERS:
            return {
                ...state,
                tradePartners: null,
                request: startFetchingRequestState()
            };
        case FETCH_OUTGOING_INVOICE_TRADE_PARTNERS_SUCCESS:
            return {
                ...state,
                tradePartners: action.tradePartners,
                request: successFetchingRequestState()
            };
        case FETCH_OUTGOING_INVOICE_TRADE_PARTNERS_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error )
            };
        case FETCH_OUTGOING_INVOICE_PROJECT_META:
            return {
                ...state,
                metaRequest: startFetchingRequestState(),
            };
        case FETCH_OUTGOING_INVOICE_PROJECT_META_SUCCESS:
            return {
                ...state,
                meta: action.projectMeta,
                metaRequest: successFetchingRequestState(),
            };
        case FETCH_OUTGOING_INVOICE_PROJECT_META_ERROR:
            return {
                ...state,
                metaRequest: errorFetchingRequestState( action.error )
            }
        default:
            return state;

    }
}